/**
 * created by wang lei
 通知公告 上传组件
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {FILE_TYPE} from "../../../constants";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import UploadWall from "../../../components/upload/UploadWall";
import {getSubffix} from "../../../utils";
import {message} from "antd";

export default class NoticeUploadWall extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            fileList:this.props.setFillList
        };
        this.chunkUpload = new ChunkUpload({
            checkFileURL:"/storage/checkFile",
            checkChunkURL:"/storage/checkChunk",
            uploadChunkURL:"/storage/uploadChunk",
            chunkUploadOverURL:"/storage/chunkIsUploadOver",
            mergeChunksURL:"/storage/mergeChunk"
        });
    }

    render() {
        let accept ="." + FILE_TYPE.join(",.");
        let array = JSON.parse(JSON.stringify(accept)).toLowerCase();
        let arr = array.split(",");
        let newArray = [];
        //打开弹框的时候  过滤掉重复的格式
        arr && arr.length && arr.forEach((item, index) => {
            if (newArray.indexOf(item) > -1) {
            } else {
                newArray.push(item)
            }
        });
        return (
            <div>
                <UploadWall
                    accept={newArray}
                    multiple={true}
                    action="/storage/uploadFile"
                    listType={'list'}
                    fileList={this.state.fileList}
                    style={{padding:'unset'}}
                    customRequest={new ChunkUpload({
                        checkFileURL:"/storage/checkFile",
                        checkChunkURL:"/storage/checkChunk",
                        uploadChunkURL:"/storage/uploadChunk",
                        chunkUploadOverURL:"/storage/chunkIsUploadOver",
                        mergeChunksURL:"/storage/mergeChunk"
                    }).start}
                    icons={["delete","download"]}
                    uploadBtnName={"点击上传"}
                    beforeUpload={(file)=>this.beforeUpload(file)}
                    onChange={this.onChange}
                    onRemove={this.handleRemove}
                />
            </div>
        )
    }
    onChange = (info) => {
        let nameExt = getSubffix(info.file&&info.file.originFileObj && info.file.originFileObj.name);
        if(FILE_TYPE.indexOf(nameExt) === -1 || nameExt === "mid" || (info.file&&info.file.originFileObj && info.file.originFileObj.type === "audio/webm")){
            message.destroy()
            message.error(`暂不支持该格式文件上传！`);
            return;
        }
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.md5 = info.file.response && info.file.response.md5;
                item.path = info.file.response && info.file.response.path;
                // item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        let newFileList = info.fileList
        //     .map(item=>({
        //     "md5": item.md5,
        //     "name": item.name,
        //     "url": item.url,
        // }));
        // this.props.onChange(JSON.parse(JSON.stringify(newFileList)));
        this.setState({
            fileList: info.fileList
        })
    };

    beforeUpload = file => {
        return new Promise((resolve, reject) => {
            let ext = getSubffix(file.name);
            if(!ext){
                message.destroy()
                message.error(`暂不支持该格式文件上传！`);
                reject();
                return;
            }else if(ext){
                if (file.size === 0) {
                    message.destroy()
                    // this.props.updateFileList(fileList);
                    message.error('空文件不能上传！');
                    reject();
                }else if(file.size !== 0){
                    if (this.state.fileList && this.state.fileList.length && this.state.fileList.length > 0) {
                        this.chunkUpload.getFileMd5(file, ({originalMd5}) => {
                            let res = this.state.fileList.find(item => {
                                if (item.md5 === originalMd5 || item.originalMd5 === originalMd5) {
                                    return true;
                                }
                                return item.xhr && item.xhr.originalMd5 === originalMd5;
                            });
                            let status = this.state.fileList.some(item => (item.originFileObj&&item.originFileObj.name === file.name) && (item.originFileObj&&item.originFileObj.size === file.size));
                            if (res || status) {
                                message.destroy()
                                message.error("文件已在列表中！");
                                reject();
                            } else {
                                resolve();
                            }
                        });
                    } else {
                        resolve();
                    }
                }
            }
            if(FILE_TYPE.indexOf(ext) === -1){
                message.destroy()
                message.error(`暂不支持该格式文件上传！`);
                reject();
                return;
            }
        });
    };

    handleRemove =  file => {
        let fileList = this.state.fileList.filter(item => (item.uid !== file.uid)||(item._id !== file._id));
        // this.props.onChange(JSON.parse(JSON.stringify(fileList)));
        this.setState({
            fileList
        },()=>{
            this.props.getFillList && this.props.getFillList(this.state.fileList)
        });
    };

    /*     onDownload = (file) => {
             console.log(file)
             this.request({
                 url:'/storage'+file.path+`?download=1`,
                 contentType: "json",
                 callBack: (data) => {
                     console.log(data)
                 }
             })
         }*/
    getFillDown(FillDown){
        return this.state.fileList
    }
}